import '../../node_modules/@splidejs/splide/dist/css/splide.min.css';
import Splide from "@splidejs/splide";

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 991) { 
        const slideCount = document.querySelectorAll('#best-seller .splide__slide').length;
        const showArrows = slideCount > 4;
        new Splide('#best-seller', {
            perPage    : 4, 
            perMove    : 1,
            pagination : false,
            arrows     : showArrows,
        }).mount();
    }
    if (window.innerWidth < 991) { 
        new Splide('#best-seller', {
            type       : 'loop',
            perPage    : 1.5, 
            perMove    : 1,
            gap        : '1rem', 
            pagination : true,
            arrows     : false,
        }).mount();
    }
});

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) { 
        new Splide('#shop-category', {
            type       : 'loop',
            perPage    : 1.5, 
            perMove    : 1,
            gap        : '1rem', 
            pagination : true,
            arrows     : false,
        }).mount();
    }
});

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) { 
        new Splide('#service-list', {
            type       : 'loop',
            perPage    : 1.5, 
            perMove    : 1,
            gap        : '1rem', 
            pagination : true,
            arrows     : false,
        }).mount();
    }
});
